import React from 'react'

export const minnesotaSetupVars = {
  siteId: 'minnesota',
  pathPrefix: '/mn',
  menuHeader: "Discover Minnesota's Solution for:",
  appUrl: 'https://mn.headed2.com',
  logoImg: '/images/assets/minnesota/horizontal/dark.svg',
  headerTitle: `The Minnesota CareerExplorer is a system designed for Minnesota`
}
